import axios from "axios";

export default {
  name: "pipeline",
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getPipelineList(store, { id,tab,jenis }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "pipeline",
          auth: {
            username: store.getters.getAuth.username,
            password: store.getters.getAuth.password,
          },
          params: { id: id, tab:tab, 
            jenis: jenis, tlc:store.getters.getAuth.username },
          headers: {
            "X-API-KEY": store.getters.getAuth.apikey,
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
